export default "__VITE_ASSET__znQsXv5k__"